import { INITIAL_PRODUCT_DISPLAY_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[INITIAL_PRODUCT_DISPLAY_MODAL_MODULE_ID]: {
		moduleType: 'modal',
		modalTitle: 'Ready Player One?',
		modalContent: {},
	},
}
